import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect, useLocation } from 'react-router-dom';
import { setCloneData } from 'src/utils/data/clone';
import generateId from 'src/utils/data/id';
import { Trans } from 'react-i18next';
import s from './CloneButton.styles';

const CloneButton = ({ values, path }) => {
  const [redirectUrl, setRedirectUrl] = useState();

  const { pathname } = useLocation();
  const onClone = () => {
    const newPathname = path || pathname.replace(/\/([0-9]+)(\/versions)?$/, '/new');
    const id = generateId();
    setCloneData(id, {
      ...values,
      id: undefined,
      draft: undefined,
    });

    setRedirectUrl(`${newPathname}#${id}`);
  };

  if (redirectUrl) return <Redirect to={redirectUrl} />;

  return (
    <s.CloneButton ghost gray onClick={() => onClone()} sm type="button" data-testid="clone-button">
      <Trans>NEW_FROM_THIS</Trans>
    </s.CloneButton>
  );
};

CloneButton.propTypes = {
  values: PropTypes.object,
  path: PropTypes.string,
};

CloneButton.defaultProps = {
  values: {},
  path: null,
};

export default CloneButton;
